export const getTiersInfo = (state) => state?.tiers?.info || {};
